<template>
  <div class="layout-img">
    <div id="image001" class="image-layout" v-show="!loading"></div>
    <div v-show="loading" class="loading">
      <loading style="width: 50px"></loading>
    </div>
  </div>
</template>

<script>
import loading from '@/components/loading.vue'
export default {
  components: {
    loading
  },
  props: {
    src: {
      type: String,
      default: ''
    },
    boxs: {
      // NOTE format ของ Box ที่ต้องการ
      type: Array,
      default: () => [
        // {
        //   xmin: 100,
        //   ymin: 100,
        //   xmax: 200,
        //   ymax: 200,
        //   confident: 0,
        //   text: "",
        //   color: "#fff",
        // },
      ]
    },
    width: {
      // NOTE ขนาดของภาพต้นฉบับ
      type: Number,
      default: 0
    },
    height: {
      // NOTE ขนาดของภาพต้นฉบับ
      type: Number,
      default: 0
    },
    brightness: {
      type: Number,
      default: 50
    },
    contrast: {
      type: Number,
      default: 50
    },
    loading: {
      type: Boolean,
      default: false
    }
  },
  watch: {
    boxs: {
      handler () {
        this.draw(this.boxs)
      },
      immediate: true
    },

    src: {
      handler () {
        this.draw(this.boxs)
      },
      immediate: true
    },
    brightness: {
      handler () {
        this.draw(this.boxs)
      }
    },
    contrast: {
      handler () {
        this.draw(this.boxs)
      }
    }
  },
  mounted () {
    const img = document.createElement('img')

    // นำ sourct ใส่ใน Element Image เพื่อแสดงรูป
    img.src = this.src
  },
  methods: {
    draw (boxs) {
      const filterValue = `brightness(${this.brightness}%) contrast(${this.contrast}%)`
      // สร้าง Element Image เพื่อใช้ในการแสดงรูป
      const img = document.createElement('img')

      // นำ sourct ใส่ใน Element Image เพื่อแสดงรูป
      img.src = this.src

      // handle Event เมื่อ Element image ที่ได้สร้างนั้นมีการ load Element สำเร็จ
      img.onload = function () {
        // ตรวจสอบว่ามี Parent ที่ต้องการจะ Append Element Image
        if (document.getElementById('canvas001') !== null) {
          // หากว่ามี Element ให้ Get Element
          const d = document.getElementById('image001')

          // Get Element Canvas เพื่อทำการ Remove Element Canvas
          const dNested = document.getElementById('canvas001')

          // หากว่ามี Element ทำการ ลบ Element Canvas อันเก่าออก
          d.removeChild(dNested)
        }

        // สร้าง Element Canvas
        const canvas = document.createElement('canvas')

        // Set Attribute ของ Canvas
        canvas.setAttribute('id', 'canvas001')
        canvas.setAttribute('style', 'width:100%')
        canvas.setAttribute('class', 'img')

        // แปลง Element Object
        const ctx = canvas.getContext('2d')

        // Get ขนาดปัจจุบันของ Image ที่แสดง และปรับขนาดของ Canvas
        // ให้มีขนาดเท่ากับ Image
        canvas.width = img.width
        canvas.height = img.height

        ctx.filter = filterValue

        // วาด Image ลงบน Canvas ที่ได้มีการสร้างไว้
        ctx.drawImage(
          img,
          0,
          0,
          img.width,
          img.height,
          0,
          0,
          canvas.width,
          canvas.height
        )

        // Set สีของเส้นที่จะวาด Rectangle
        ctx.strokeStyle = 'red'

        // Set ขนาดของความกว้างของเส้น
        ctx.lineWidth = 3

        // loop boxs ทั้งหมดที่ต้องการวาด
        for (let index = 0; index < boxs.length; index++) {
          // Create Local Variable
          let startX = 0
          let startY = 0
          let width = 0
          let height = 0

          // Loop สำหรับตีกรอบสี่เหลี่ยม
          if (boxs[index].xmax > boxs[index].xmin) {
            startX = boxs[index].xmin
            startY = boxs[index].ymin
            width = Math.abs(boxs[index].xmax - boxs[index].xmin)
            height = Math.abs(boxs[index].ymax - boxs[index].ymin)
          } else {
            startX = boxs[index].xmax
            startY = boxs[index].ymax
            width = Math.abs(boxs[index].xmax - boxs[index].xmin)
            height = Math.abs(boxs[index].ymax - boxs[index].ymin)
          }

          // วาดกล่องลงบน Canvas
          ctx.rect(startX, startY, width, height)

          // Set Font size และ Font Family
          ctx.font = '30px Arial'

          // Set Font color
          ctx.fillStyle = 'red'

          // เขียนข้อความลงบน Canvas
          if (startX <= 0) {
            ctx.fillText(`${boxs[index].confident}%`, startX, startY + 30)
          } else {
            ctx.fillText(`${boxs[index].confident}%`, startX, startY - 5)
          }
        }

        //
        ctx.stroke()

        // แปะ Element Canvas ไปยัง Parent Element
        document.getElementById('image001').appendChild(canvas)
      }
    }
  }
}
</script>

<style scoped>
.layout-img {
  width: 100% !important;
  height: 100% !important;
  /* background-color: red; */
}

::v-deep .image-layout .img , .loading{
  /* background: green; */
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translateX(-50%) translateY(-50%);
  max-width: 100%;
  max-height: 100%;
  /* width: auto; */
  /* height: 300px !important; */
  object-fit: contain;
}
</style>
